import React, { memo, RefCallback, useMemo } from 'react';
import { createElementKey } from 'utils';
import {
  mediaDesktop,
  mediaDesktopX2,
  mediaLargeDesktop,
  mediaLargeDesktopX2,
  mediaMoreThenMobile,
  mediaMoreThenMobileX2,
  mediaMobile,
  mediaMobileX2,
} from './picture-constants';
import { PictureDesktopNames } from './picture-enums';
import { PictureTransformations } from './picture-types';
import { getImageSrc } from './picture-utils';

type PictureProps = {
  transformations: PictureTransformations;
  refCb?: RefCallback<HTMLImageElement>;
} & JSX.ReactHTMLImageElement;

export const Picture: React.FC<PictureProps> = memo(({ alt, src, transformations, refCb, ...rest }) => {
  const pictureProps = useMemo(
    () => [
      {
        media: mediaLargeDesktopX2,
        srcSet: getImageSrc(src, transformations[PictureDesktopNames.ImgLargeDesk], true),
      },
      {
        media: mediaLargeDesktop,
        srcSet: getImageSrc(src, transformations[PictureDesktopNames.ImgLargeDesk], false),
      },
      {
        media: mediaDesktopX2,
        srcSet: getImageSrc(src, transformations[PictureDesktopNames.ImgDesk], true),
      },
      {
        media: mediaDesktop,
        srcSet: getImageSrc(src, transformations[PictureDesktopNames.ImgLargeDesk], false),
      },
      {
        media: mediaMoreThenMobileX2,
        srcSet: getImageSrc(src, transformations[PictureDesktopNames.ImgTablet], true),
      },
      {
        media: mediaMoreThenMobile,
        srcSet: getImageSrc(src, transformations[PictureDesktopNames.ImgTablet], false),
      },
      {
        media: mediaMobileX2,
        srcSet: getImageSrc(src, transformations[PictureDesktopNames.ImgMobile], true),
      },
      {
        media: mediaMobile,
        srcSet: getImageSrc(src, transformations[PictureDesktopNames.ImgMobile], false),
      },
    ],
    [transformations, src]
  );

  return (
    <picture>
      {pictureProps.map(({ media, srcSet }, index) => (
        <source key={createElementKey('source', index)} media={media} srcSet={srcSet} />
      ))}

      <img alt={alt} src={pictureProps[2].srcSet} ref={refCb} {...rest} />
    </picture>
  );
});
